import { useEffect, useRef, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";

// Polls a cheap version counter; when the owner changes inventory, refetch the catalogue.
export function useCatalogSync() {
  const qc = useQueryClient();
  const last = useRef(null);
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  const { data } = useQuery({
    queryKey: ["catalog-version"],
    queryFn: publicApi.version,
    refetchInterval: 10000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  useEffect(() => {
    if (data?.version === undefined) {
      return;
    }
    if (last.current !== null && last.current !== data.version) {
      qc.invalidateQueries({ queryKey: ["products"] });
      qc.invalidateQueries({ queryKey: ["categories"] });
      qc.invalidateQueries({ queryKey: ["product"] });
      qc.invalidateQueries({ queryKey: ["settings"] });
    }
    last.current = data.version;
  }, [data, qc]);

  useEffect(() => {
    const on = () => { setOnline(true); qc.invalidateQueries({ queryKey: ["catalog-version"] }); };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, [qc]);

  return { online };
}
